import React, { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
const EMAILJS_SERVICE_ID = 'service_doctorecommerce';
const EMAILJS_TEMPLATE_ID = 'template_legal_lead';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
const CALENDAR_URL = 'https://calendar.app.google/gDsqAVqmwUYmaZHe9';
export function ContactFormSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, e.currentTarget, EMAILJS_PUBLIC_KEY);
      setSubmitStatus('success');
      e.currentTarget.reset();
    } catch (error) {
      console.error('EmailJS Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contacto" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-carbon relative border-t border-white/5" data-id="element-8">
      <div className="max-w-3xl mx-auto" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-10">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-gold mb-4" data-id="element-11">
            Solicita Tu Diagnóstico Gratuito
          </h2>
          <p className="font-body text-base sm:text-lg text-gray-400" data-id="element-12">
            Completa el formulario y un especialista en marketing legal te
            contactará en menos de 24 horas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#111] border border-white/10 rounded-2xl p-6 sm:p-10 shadow-2xl" data-id="element-13">
          {submitStatus === 'success' ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-14">
              <CheckCircleIcon className="w-16 h-16 text-emerald mb-6" data-id="element-15" />
              <h3 className="font-heading text-2xl font-bold text-white mb-2" data-id="element-16">
                ¡Solicitud enviada!
              </h3>
              <p className="font-body text-gray-400 mb-8" data-id="element-17">
                Te contactaremos en menos de 24 horas.
              </p>
              <button onClick={() => setSubmitStatus('idle')} className="text-gold hover:text-gold-light font-semibold underline underline-offset-4" data-id="element-18">
                Enviar otra solicitud
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-19">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-20">
                {/* Nombre */}
                <div className="space-y-2" data-id="element-21">
                  <label htmlFor="user_name" className="block font-body text-sm font-medium text-gray-300" data-id="element-22">
                    Nombre completo *
                  </label>
                  <input type="text" id="user_name" name="user_name" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Ej. Lic. Roberto Méndez" data-id="element-23" />
                </div>

                {/* Email */}
                <div className="space-y-2" data-id="element-24">
                  <label htmlFor="user_email" className="block font-body text-sm font-medium text-gray-300" data-id="element-25">
                    Email *
                  </label>
                  <input type="email" id="user_email" name="user_email" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="roberto@tufirma.com" data-id="element-26" />
                </div>

                {/* Teléfono */}
                <div className="space-y-2" data-id="element-27">
                  <label htmlFor="user_phone" className="block font-body text-sm font-medium text-gray-300" data-id="element-28">
                    Teléfono *
                  </label>
                  <input type="tel" id="user_phone" name="user_phone" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="(555) 123-4567" data-id="element-29" />
                </div>

                {/* Nombre de Firma */}
                <div className="space-y-2" data-id="element-30">
                  <label htmlFor="company_name" className="block font-body text-sm font-medium text-gray-300" data-id="element-31">
                    Nombre de tu firma legal *
                  </label>
                  <input type="text" id="company_name" name="company_name" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Méndez Law Group" data-id="element-32" />
                </div>

                {/* Instagram */}
                <div className="space-y-2" data-id="element-33">
                  <label htmlFor="instagram" className="block font-body text-sm font-medium text-gray-300" data-id="element-34">
                    Instagram de tu firma
                  </label>
                  <input type="text" id="instagram" name="instagram" className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="@tufirma" data-id="element-35" />
                </div>

                {/* Website */}
                <div className="space-y-2" data-id="element-36">
                  <label htmlFor="website" className="block font-body text-sm font-medium text-gray-300" data-id="element-37">
                    Website
                  </label>
                  <input type="url" id="website" name="website" className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="https://tufirma.com" data-id="element-38" />
                </div>
              </div>

              {/* Área de especialización */}
              <div className="space-y-2" data-id="element-39">
                <label htmlFor="specialty" className="block font-body text-sm font-medium text-gray-300" data-id="element-40">
                  ¿Cuál es tu área de especialización? *
                </label>
                <select id="specialty" name="specialty" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-41">
                  <option value="" data-id="element-42">Selecciona una opción</option>
                  <option value="Inmigración" data-id="element-43">Inmigración</option>
                  <option value="Accidentes Personales" data-id="element-44">
                    Accidentes Personales
                  </option>
                  <option value="Derecho de Familia" data-id="element-45">Derecho de Familia</option>
                  <option value="Derecho Criminal" data-id="element-46">Derecho Criminal</option>
                  <option value="Otra" data-id="element-47">Otra</option>
                </select>
              </div>

              {/* Clientes actuales */}
              <div className="space-y-2" data-id="element-48">
                <label htmlFor="current_clients" className="block font-body text-sm font-medium text-gray-300" data-id="element-49">
                  ¿Cuántos clientes nuevos recibes por semana? *
                </label>
                <select id="current_clients" name="current_clients" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-50">
                  <option value="" data-id="element-51">Selecciona una opción</option>
                  <option value="0-2" data-id="element-52">0-2</option>
                  <option value="3-5" data-id="element-53">3-5</option>
                  <option value="6-10" data-id="element-54">6-10</option>
                  <option value="10+" data-id="element-55">10+</option>
                </select>
              </div>

              {/* Meta de clientes */}
              <div className="space-y-2" data-id="element-56">
                <label htmlFor="goal_clients" className="block font-body text-sm font-medium text-gray-300" data-id="element-57">
                  ¿Cuál es tu meta de clientes nuevos por semana? *
                </label>
                <select id="goal_clients" name="goal_clients" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-58">
                  <option value="" data-id="element-59">Selecciona una opción</option>
                  <option value="5-10" data-id="element-60">5-10</option>
                  <option value="10-20" data-id="element-61">10-20</option>
                  <option value="20-50" data-id="element-62">20-50</option>
                  <option value="50+" data-id="element-63">50+</option>
                </select>
              </div>

              {/* Experiencia en Ads */}
              <div className="space-y-2" data-id="element-64">
                <label htmlFor="ads_experience" className="block font-body text-sm font-medium text-gray-300" data-id="element-65">
                  ¿Has invertido en publicidad digital antes? *
                </label>
                <select id="ads_experience" name="ads_experience" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-66">
                  <option value="" data-id="element-67">Selecciona una opción</option>
                  <option value="No nunca" data-id="element-68">No, nunca</option>
                  <option value="Sí pero sin resultados" data-id="element-69">
                    Sí, pero sin resultados
                  </option>
                  <option value="Sí con algunos resultados" data-id="element-70">
                    Sí, con algunos resultados
                  </option>
                  <option value="Sí con buenos resultados" data-id="element-71">
                    Sí, con buenos resultados
                  </option>
                </select>
              </div>

              {/* Inversión en Ads */}
              <div className="space-y-2" data-id="element-72">
                <label htmlFor="ads_spend" className="block font-body text-sm font-medium text-gray-300" data-id="element-73">
                  ¿Cuánto has invertido en publicidad en los últimos 12 meses? *
                </label>
                <select id="ads_spend" name="ads_spend" required className="w-full bg-carbon border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-74">
                  <option value="" data-id="element-75">Selecciona una opción</option>
                  <option value="Nada" data-id="element-76">Nada</option>
                  <option value="Menos de $1,000" data-id="element-77">Menos de $1,000</option>
                  <option value="$1,000 - $5,000" data-id="element-78">$1,000 - $5,000</option>
                  <option value="$5,000 - $15,000" data-id="element-79">$5,000 - $15,000</option>
                  <option value="Más de $15,000" data-id="element-80">Más de $15,000</option>
                </select>
              </div>

              {submitStatus === 'error' && <div className="flex items-center gap-2 text-red-400 bg-red-400/10 p-4 rounded-lg" data-id="element-81">
                  <AlertCircleIcon className="w-5 h-5 shrink-0" data-id="element-82" />
                  <span className="text-sm" data-id="element-83">
                    Hubo un error. Por favor intenta de nuevo o llámanos al
                    (402) 872-0639.
                  </span>
                </div>}

              <button type="submit" disabled={isSubmitting} className="w-full py-4 px-6 text-lg font-bold text-carbon bg-gold hover:bg-gold-light transition-colors duration-300 rounded-lg shadow-[0_0_15px_rgba(242,183,5,0.2)] hover:shadow-[0_0_25px_rgba(242,183,5,0.4)] focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-carbon disabled:opacity-70 disabled:cursor-not-allowed mt-4" data-id="element-84">
                {isSubmitting ? 'ENVIANDO...' : 'ENVIAR SOLICITUD'}
              </button>
            </form>}
        </motion.div>

        <div className="mt-8 text-center" data-id="element-85">
          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="font-body text-sm sm:text-base text-gray-400 hover:text-gold transition-colors underline underline-offset-4" data-id="element-86">
            También puedes agendar directamente tu diagnóstico gratuito →
          </a>
        </div>
      </div>
    </section>;
}